var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuantityIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".8vw",
    height: ".75vw",
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 3.10156L13.9932 5.07031V10.416L10.0625 12.3848L6.125 10.4297V8.23535L3.9375 9.32227L0 7.36719L0.00683594 2.00781L3.9375 0.0390625L7.86816 2.00781L7.875 4.20215L10.0625 3.10156ZM12.5781 5.33691L10.0625 4.08594L7.54688 5.33691L10.0625 6.59473L12.5781 5.33691ZM6.45312 2.27441L3.9375 1.02344L1.42188 2.27441L3.9375 3.53223L6.45312 2.27441ZM0.881836 2.98535L0.875 6.82031L3.5 8.12598V4.29102L0.881836 2.98535ZM4.375 8.12598L6.13184 7.25781V5.07031L7 4.63965L6.99316 2.98535L4.375 4.29102V8.12598ZM7.00684 6.04785L7 9.88281L9.625 11.1885V7.35352L7.00684 6.04785ZM10.5 11.1885L13.1182 9.87598V6.04785L10.5 7.35352V11.1885Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantityIcon);
export default __webpack_public_path__ + "static/media/quantity_Icon.1aa4c70aab8267b39fb5f26514481214.svg";
export { ForwardRef as ReactComponent };